import { render, staticRenderFns } from "./PopUpShow.vue?vue&type=template&id=0e415cf8&"
import script from "./PopUpShow.vue?vue&type=script&lang=js&"
export * from "./PopUpShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports